import gql from 'graphql-tag';

export const UPDATE_TEMPLATE = gql`
  mutation UpdateTemplate($input: UpdateBusinessProcessFlowTemplateInput!) {
    bpf {
      updateTemplate(input: $input) {
        businessProcessFlowId
      }
    }
  }
`;
